export { default } from '@stimulus-components/clipboard'
